import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { AppRoutes } from "./routes";
import { useAppDispatch } from "./hooks/useAppStore";
import { fetchAdminMe } from "./store/slices/adminAuthSlice";
import { ToastContainer } from "./components/ui/Toast";

// Auth lives in an httpOnly cookie the client can't read, so rehydrate by
// asking the backend whether a session exists rather than checking localStorage.
const AuthInit: React.FC<{ onReady: () => void }> = ({ onReady }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAdminMe()).finally(onReady);
  }, [dispatch, onReady]);
  return null;
};

const AppWithStore: React.FC = () => {
  const [authReady, setAuthReady] = useState(false);
  return (
    <>
      <AuthInit onReady={() => setAuthReady(true)} />
      {authReady ? (
        <AppRoutes />
      ) : (
        <div className="flex items-center justify-center  bg-charcoal">
          <div className="w-8 h-8 border-2 border-magenta border-t-transparent rounded-lg animate-spin" />
        </div>
      )}
      <ToastContainer />
    </>
  );
};

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <AppWithStore />
    </BrowserRouter>
  </Provider>
);

export default App;
